import { getRecoil } from "recoil-nexus";
import { fnolQuestionSetState } from "atoms/fnolQuestionSetState.atom";
import { fnolInstanceState } from "atoms/fnolInstanceState.atom";
import { isNullOrEmpty } from "shared/Helpers";
import { dateTimeWhenFNOLOpenedState } from "atoms/dateTimeWhenFNOLOpenedState";

export const getFnolQuestionSet = () => {
  return new Promise((resolve) => {
    const fnolQuestionSet = getRecoil(fnolQuestionSetState);
    const fnol = [...fnolQuestionSet];
    resolve(fnol);
  });
};

export const getFnolInstanceFieldObject = (fieldMapping) => {
  return new Promise((resolve) => {
    getFnolQuestionSet()
      .then((fnol) => {
        if (!isNullOrEmpty(fieldMapping)) {
          const propsData = fnol.find((c) => c.fieldMapping === fieldMapping);
          resolve(!isNullOrEmpty(propsData) ? propsData : null);
        }
      })
      .catch((exception) => {
        console.log(exception);
        resolve(null);
      });
  });
};

export const getCreatedDateTimeOfFNOL = () => {
  return getRecoil(dateTimeWhenFNOLOpenedState);
};
